import { httpClient } from '@/services/http/httpClient'

export type Portfolio = {
  id: string
  title: string
}

type GetPortfolioResponse = {
  portfolios: Portfolio[]
}

export async function getPortfolios(): Promise<GetPortfolioResponse> {
  const { data } = await httpClient.get<GetPortfolioResponse>(
    '/projects/portfolios/',
  )

  return data
}
